import type { FC } from 'react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import { styled } from '@compiled/react';

import { ButtonItem } from '@atlaskit/menu';
import { token } from '@atlaskit/tokens';

import { ContentIcon } from '@confluence/icons/entry-points/ContentIcon';

import type { CreateSpaceDisplayItemProps } from './CreateSpaceButton';

const i18n = defineMessages({
	createASpace: {
		id: 'create-space.menu-item-with-icon',
		defaultMessage: 'Space',
		description:
			'Text for button in the global Create dropdown that opens the create space dialog where users can create a new space.',
	},
});

const nonStandardIconSize = '18px !important';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentIconWrapper = styled.div({
	display: 'flex',
	flexShrink: '0',
	justifyContent: 'center',
	width: token('space.300'),

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'svg, span': {
		height: nonStandardIconSize,
		width: nonStandardIconSize,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentTitle = styled.div({
	fontWeight: token('font.weight.medium'),
	color: token('color.text'),
});

const Title = (
	<ContentTitle>
		<FormattedMessage {...i18n.createASpace} />
	</ContentTitle>
);

const Avatar = (
	<ContentIconWrapper>
		<ContentIcon type="space" />
	</ContentIconWrapper>
);

export const CreateSpaceMenuItemNav3WithIcon: FC<CreateSpaceDisplayItemProps> = ({
	onClick,
	onMouseDown,
}) => (
	<ButtonItem
		iconBefore={Avatar}
		onClick={onClick}
		onMouseDown={onMouseDown}
		aria-haspopup="dialog"
		testId="create-menu-link-item"
	>
		{Title}
	</ButtonItem>
);
